module.exports = __webpack_public_path__ + "images/unload-icon.710df22ff7583d88e8cef76bbddae439.png";